import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Calendar from 'components/molecules/Calendar';
import { DayType } from 'components/molecules/Calendar';
import { getCalendar } from 'store/programDays';

const getNumberSignature = (n?: number) => {
	// old way was `number || 0` which means there is no difference between `number = undefined` and `number = 0`
	// PULSWM-3277
	return typeof n === 'number' ? `${n}` : '';
};

export const getDaySignature = (day: DayType): string => {
	const itemSignature = `I-${getNumberSignature(day.openItems)}${getNumberSignature(day.totalItems)}`;
	return `${day.isToday ? 'T-' : ''}${day.date ? `${day.date}-` : ''}${itemSignature}`;
};

const mapStateToProps = (state: any, ownProps: { selectedDayNumber: number }) => {
	const days = (getCalendar as any)(state, ownProps.selectedDayNumber);

	return {
		days,
		signature: days.length === 0 ? 'initial' : `${days.length}:${days.map(getDaySignature).join('|')}`,
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Calendar);
